export const NO_DISPUTE = '0'
export const WAITING_SENDER = '1'
export const WAITING_RECEIVER = '2'
export const DISPUTE_CREATED = '3'
export const DISPUTE_RESOLVED = '4'
